import React, { useState } from 'react';
import '../css/Login.css';
import Logo from '../components/Logo';

const users = [
  { username: 'carolinaconcrete', password: 'admin2015', name: 'Carolina Concrete' },
  { username: 'lgmetal', password: 'admin2015', name: 'L&G Metals' },
  // Add more users as needed
];

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleLogin = () => {
    const user = users.find((user) => user.username === username && user.password === password);
    if (user) {
      onLogin(user);
    } else {
      setError('Invalid username or password.');
    }
  };

  return (
    <div className="login-container">
      <img src="https://drive.google.com/uc?export=view&id=1bffQnVDDnpcdD43h_H-W7_yk8JtVpWAS"  alt="User Logo" />
      <h2>Login</h2>
      <div>
        <input type="text" value={username} onChange={handleUsernameChange} placeholder="Username" />
      </div>
      <div>
        <input type="password" value={password} onChange={handlePasswordChange} placeholder="Password" />
      </div>
      <div>
        <button onClick={handleLogin}>Login</button>
      </div>
      {error && <p className="error">{error}</p>}
    </div>
  );
}

export default Login;
